export default "__VITE_PUBLIC_ASSET__3f144af0__"